import React from "react";

export default function EmptyState({ title = "Veri yok", description = "", icon = "fas fa-inbox" }) {
  return (
    <div className="text-center py-5">
      <i className={`${icon} fa-3x text-muted mb-3`} />
      <h4 className="text-muted">{title}</h4>
      {description && <p className="text-muted">{description}</p>}
    </div>
  );
}
